/**
 * Upload File Card Component
 *
 * Placeholder for vendor cost file upload feature (MVP: Coming Soon).
 * Future: Will support Excel/CSV upload with field mapping workflow.
 */

import { Card, Button, Typography, Space } from 'antd'
import { UploadOutlined, InboxOutlined } from '@ant-design/icons'

const { Text, Paragraph } = Typography

export function UploadFileCard() {
  return (
    <Card title="Upload File">
      <div style={{ textAlign: 'center', padding: '32px 0' }}>
        <InboxOutlined style={{ fontSize: 48, color: '#d9d9d9', marginBottom: 16 }} />
        <Space direction="vertical" size="small">
          <Text strong>Coming Soon</Text>
          <Paragraph type="secondary" style={{ marginBottom: 16 }}>
            Upload vendor cost files (Excel, CSV) to create draft offerings with automatic field mapping.
          </Paragraph>
          <Button type="default" icon={<UploadOutlined />} disabled>
            Upload File
          </Button>
        </Space>
      </div>
    </Card>
  )
}
